module.exports = __webpack_public_path__ + "img/tamamlayici-saglik-sigortasi.310c1daf.svg";